/* eslint-disable */

<template>
  <div class="vx-row Lgx202142297964412928">
    <div class="vx-col w-full">
      <vx-card class="mb-base">
        <div class="fourth-sim pt-0 pb-0 pl-4">
          <div class="vx-row mb-4">
            <div class="vx-col w-1/3 flex items-center pl-0">
              <h2 class="font-bold">Name of Algorithm</h2>
            </div>
            <div class="vx-col w-1/3 flex items-center">
              <h2 class="font-bold">Type of Encryption</h2>
            </div>
            <div class="vx-col w-1/3 flex items-center">
              <h2 class="font-bold">Functionality</h2>
            </div>
          </div>
          <div class="vx-row rounded-lg bg-light main-border mt-4" v-for="item in table_items" :key="item.id">
            <div class="vx-col w-1/3 flex items-center p-3">
              <h4 class="pr-24">{{ item.description }}</h4>
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select
                placeholder="Select a type of encryption"
                class="w-full"
                :options="column_1_options"
                v-model="item.column_1_selected"
              />
              <small v-if="item.column_1_is_correct !== null && item.column_1_is_correct === false" class="ml-1 text-danger font-semibold"
                >This answer is invalid</small
              >
              <small v-if="item.column_1_is_correct !== null && item.column_1_is_correct === true" class="ml-1 text-success font-semibold"
                >This answer is correct</small
              >
            </div>
            <div class="vx-col w-1/3 p-3">
              <v-select
                placeholder="Select an action from the dropdown"
                class="w-full"
                :options="column_2_options"
                v-model="item.column_2_selected"
              />
              <small v-if="item.column_2_is_correct !== null && item.column_2_is_correct === false" class="ml-1 text-danger font-semibold"
                >This answer is invalid</small
              >
              <small v-if="item.column_2_is_correct !== null && item.column_2_is_correct === true" class="ml-1 text-success font-semibold"
                >This answer is correct</small
              >
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      update_index: 0,

      table_items: [
        {
          id: 1,
          icon: '',
          description: 'AES256',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 1,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 2,
          icon: '',
          description: 'RSA',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 2,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 3,
          icon: '',
          description: 'Diffie Hellman',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 2,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 4,
          icon: '',
          description: 'Blowfish & Twofish',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 1,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 5,
          icon: '',
          description: 'ECC',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 2,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 6,
          icon: '',
          description: 'DES & 3DES',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 1,
          column_2_correct: 2,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 7,
          icon: '',
          description: 'MD5 and SHA1',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 3,
          column_2_correct: 3,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 8,
          icon: '',
          description: 'NTLM',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 3,
          column_2_correct: 3,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
        {
          id: 9,
          icon: '',
          description: 'SHA 512',
          column_1_selected: null,
          column_2_selected: null,
          column_1_correct: 3,
          column_2_correct: 3,
          column_1_is_correct: null,
          column_2_is_correct: null,
        },
      ],

      column_1_options: [
        { id: 1, label: 'Symmetric' },
        { id: 2, label: 'Asymmetric' },
        { id: 3, label: 'Hashing' },
      ],

      column_2_options: [
        { id: 1, label: 'Availability' },
        { id: 2, label: 'Confidentiality' },
        { id: 3, label: 'Integrity' },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      this.table_items.forEach((x, i) => {
        if (x.column_1_selected && x.column_1_selected.id === x.column_1_correct) {
          this.table_items[i].column_1_is_correct = true;
          totalScore++;
        } else {
          this.table_items[i].column_1_is_correct = false;
        }
        if (x.column_2_selected && x.column_2_selected.id === x.column_2_correct) {
          totalScore++;
          this.table_items[i].column_2_is_correct = true;
        } else {
          this.table_items[i].column_2_is_correct = false;
        }
      });

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    Prism,
    vSelect,
    shuffle,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style>
.Lgx202142297964412928 {
  font-size: 14px;
}

.theme-dark .v-select .vs__dropdown-toggle {
  background: #02050d;
}

.theme-dark .v-select .vs__dropdown-menu {
  background: #02050d;
}

.theme-dark .vx-card input {
  background: #02050d;
}
</style>
